import { render, staticRenderFns } from "./FeedbackShortcuts.vue?vue&type=template&id=31f1aef5&scoped=true"
import script from "./FeedbackShortcuts.vue?vue&type=script&lang=ts"
export * from "./FeedbackShortcuts.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackShortcuts.vue?vue&type=style&index=0&id=31f1aef5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f1aef5",
  null
  
)

export default component.exports